import { credentialStatus } from '@shared/schema/credentialStatus.js';
import CredentialStatusIcon from './CredentialStatusIcon.jsx';

const CredentialStatusTag = ({ credential }) => {
  credential.status = credential?.status || 'incomplete';

  return (
    <div //
      className={`comp-credential-status-tag`}
      data-title={credentialStatus[credential?.status]?.description}
      style={{ backgroundColor: credentialStatus[credential?.status]?.backgroundColor, color: credentialStatus[credential?.status]?.textColor }}>
      <CredentialStatusIcon credential={credential} />
      {credentialStatus[credential?.status]?.label}
    </div>
  );
};

export default CredentialStatusTag;
